import React, {ReactNode} from 'react';
import {Link} from 'react-router-dom';

interface AppNavLinkProps {
  [x: string]: any;
  to: string;
  children: ReactNode;
}

const AppNavLink: React.FC<AppNavLinkProps> = ({to, children, ...rest}) => (
  <Link to={to} {...rest}>
    <>{children}</>
  </Link>
);

export default AppNavLink;
